import React, { createContext, useState, useContext } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [selectedContrast, setSelectedContrast] = useState("light");
  return (
    <ThemeContext.Provider value={{ selectedContrast, setSelectedContrast }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
